import { apiClient, clearTokens, setTokens } from '@/lib/api-client';
import type { AuthVerifyRequest, AuthVerifyResponse, User } from '@/types/api';

export const authService = {
  /**
   * Verify OAuth token with backend
   */
  async verify(
    provider: 'google',
    idToken: string
  ): Promise<AuthVerifyResponse> {
    const { data } = await apiClient.post<AuthVerifyResponse>(
      `/v3/auth/email/${provider}?offline_mode=true`,
      {
        id_token: idToken,
      }
    );

    // Store tokens
    if (data.accessToken && data.refreshToken) {
      setTokens(data.accessToken, data.refreshToken);
    }

    return data;
  },

  /**
   * Get current user profile
   */
  async getProfile(): Promise<User> {
    const { data } = await apiClient.get<User>('/v2/user/me');
    return data;
  },

  /**
   * Logout user
   */
  logout() {
    clearTokens();
  },
};

